var star = "https://shopfront-cdn.tekoapis.com/static/6571a6180d3cbf15.svg";

export { star as default };
